<app-breadcrumb [master]="'Sprzedaż'" [parentName]="'Raporty'" [name]="'Raporty'"></app-breadcrumb>
<div class="sold-policy-report" fxLayout="column" fxLayoutGap="15px" [formGroup]="soldPolicyReportForm">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Szczegóły raportu</h3>
          </div>

          <div fxLayout="row">
            <app-dict
              fxFlex="100"
              label="Firma"
              dictType="company"
              [control]="companyControl"
              [required]="false"
              [multiple]="true"
            ></app-dict>
          </div>

          <div fxLayout="row">
            <app-dict-insurance-companies
              fxFlex="100" label="TU"
              [required]="false"
              [control]="insuranceCompanyControl"
              [multiple]="true"
            ></app-dict-insurance-companies>
          </div>

          <div fxLayout="row">
            <app-dict-regionals
              fxFlex="100"
              [multiple]="true" label="Regionalny (majątek)"
              [required]="false"
              [control]="regionalControl"
            ></app-dict-regionals>
          </div>

          <div fxLayout="row">
            <app-dict-partners
              fxFlex="100"
              [multiple]="true" [required]="false"
              label="Partner" [control]="partnerControl"
              (selectedPartners)="onPartnerSelect($event)"
            ></app-dict-partners>
          </div>

          <div fxLayout="row" *ngIf="selectedPartners.length > 0">
            <mat-form-field fxFlex="100">
              <mat-label>Placówka</mat-label>
              <mat-select [formControl]="facilityControl" [required]="false" [multiple]="true">
                <mat-optgroup *ngFor="let partner of selectedPartners" [label]="partner.shortName">
                  <ng-container *ngFor="let facility of partner.facilities">
                    <mat-option [value]="facility.address.uuid">
                      {{facility.address.searchString}}
                    </mat-option>
                  </ng-container>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxLayout="row">
            <app-dict-ofwcas
              fxFlex="100"
              [multiple]="true" [required]="false"
              label="OFWCA" [control]=""
            ></app-dict-ofwcas>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="50">
              <app-datepicker
                label="Data zawarcia od"
                placeholder="2000-01-01"
                [required]="true"
                [control]="concludeDateFromControl"
              ></app-datepicker>
            </div>

            <div fxFlex="50">
              <app-datepicker
                label="Data zawarcia do"
                placeholder="2000-01-01"
                [required]="true"
                [control]="concludeDateToControl"
              ></app-datepicker>
            </div>
          </div>

          <div fxLayout="row">
            <mat-form-field fxFlex="100">
              <mat-label>Grupowanie</mat-label>
              <mat-select [formControl]="groupingControl" [required]="true" [multiple]="true">
                <mat-option value="company">
                  Firma
                </mat-option>
                <mat-option value="insuranceCompany">
                  TU
                </mat-option>
                <mat-option value="assetsRegional">
                  Regionalny (majątek)
                </mat-option>
                <mat-option value="partner">
                  Partner
                </mat-option>
                <mat-option value="facility">
                  Placówka
                </mat-option>
                <mat-option value="ofwca">
                  OFWCA
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxFlex="100">
              <mat-slide-toggle
                color="accent"
                [formControl]="historicalStructureControl"
              >Struktura historyczna (na dzień raportu)</mat-slide-toggle>
          </div>

        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="createReport()" [class.spinner]="processingRequest"
            [disabled]="!soldPolicyReportFormValid"
            mat-stroked-button color="primary"><mat-icon>summarize</mat-icon> <span> Generuj raport</span></button>
  </div>
</div>
